////////////////////////////////////////////////////////////////////////////////////////////////
//                                                                                            //
//                      Change password page functionality done over here.                    //
//                                                                                            //
////////////////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";

/**IMPORTED FILES */
// import logo from "../../assets/images/logo.png";



const ChangePassword = props => {

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      oldPassword: "" || '',
      password: "" || '',
      confirmPassword : "" || '',
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Please Enter Your Old password"),
      password: Yup.string().required("Please Enter Your Password"),
      confirmPassword: Yup.string().required("Please Enter Your Confirm Password"),
    }),
    onSubmit: (values) => {
    let username = localStorage.getItem('userName');
    let updatePwdValues =   {
        userName : username,// 
        password : values.oldPassword,
        newpassword : values.password,
        confirmnewpassword : values.confirmPassword
      }

    }
  });


  // useEffect(() => {
  //   document.body.className = "bg-pattern";
  //   // remove classname when component will unmount
  //   return function cleanup() {
  //     document.body.className = "";
  //   };
  // });

  return (
    <React.Fragment>
      <div className="bg-overlay login-bg">
        <div className="auth-pages my-5 pt-5">
          <Container>
            <Row className="justify-content-center login-box">
              <Col lg={6} md={8} xl={4}>
                <Card>
                  <CardBody className="p-4">
                    <div>
                        <div className="text-center">
                            <Link to="/">
                            {/* <img
                                src={logo}
                                alt=""
                                height="50"
                                className="auth-logo logo-dark mx-auto"
                            />
                            <img
                                src={logo}
                                alt=""
                                height="50"
                                className="auth-logo logo-light mx-auto"
                            /> */}
                            </Link>
                        </div>
                        <h4 className="font-size-18 text-muted mt-2 text-center">
                            Change Password
                        </h4>
                        <p className="mb-5 text-center">
                            Update password to continue with Quoting Software.
                        </p>
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                        }}
                       >
                        {/* {error ? <Alert color="danger"><div>{error}</div></Alert> : null} */}
                        <Row>
                        <Col md={12}>
                        <div className="mb-4">
                            <Label className="form-label">Old password</Label>
                            <Input
                                name="oldPassword"
                                value={validation.values.oldPassword || ""}
                                type="text"
                                placeholder="Enter Old Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                validation.touched.oldPassword && validation.errors.oldPassword ? true : false
                                }
                            />
                            {validation.touched.oldPassword && validation.errors.oldPassword ? (
                                <FormFeedback type="invalid"><div> {validation.errors.oldPassword} </div></FormFeedback>
                            ) : null}
                            </div>

                            <div className="mb-4">
                            <Label className="form-label">Password</Label>
                            <Input
                                name="password"
                                value={validation.values.password || ""}
                                type="password"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                validation.touched.password && validation.errors.password ? true : false
                                }
                            />
                            {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid"><div> {validation.errors.password} </div></FormFeedback>
                            ) : null}
                            </div>

                            <div className="mb-4">
                            <Label className="form-label">Confirm Password</Label>
                            <Input
                                name="confirmPassword"
                                value={validation.values.confirmPassword || ""}
                                type="password"
                                placeholder="Enter Confirm Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                                }
                            />
                            {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                <FormFeedback type="invalid"><div> {validation.errors.confirmPassword} </div></FormFeedback>
                            ) : null}
                            </div>
                            <div className="d-grid mt-4">
                            <button
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                            >
                                Update Password
                            </button>
                            </div>
                        </Col>
                        </Row>
                    </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                    <p className="text-white-50">Go back to <Link to="/login" className="fw-medium text-primary"> Login  </Link> </p>
                </div>
             </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangePassword;

